<template>
<div class="chapter">
<div class="inner_page">
<h2>VOL. 1 </h2>
<h2 class="h1" id="sigil_toc_id_1">CONTENTS</h2>
<div class="center"><a href="#/Text/Section0003#CHAPTER_I">CHAPTER I</a><br class="calibre"/>
<a href="#/Text/Section0004#CHAPTER_II">CHAPTER II</a><br class="calibre"/>
<a href="#/Text/Section0005#CHAPTER_III">CHAPTER III</a><br class="calibre"/>
<a href="#/Text/Section0006#CHAPTER_IV">CHAPTER IV</a><br class="calibre"/>
<a href="#/Text/Section0007#CHAPTER_V">CHAPTER V</a><br class="calibre"/>
<span href="#/Text/Section0008#CHAPTER_VI" title="Link target outside of Sample">CHAPTER VI</span><br class="calibre"/>
<span href="#/Text/Section0009#CHAPTER_VII" title="Link target outside of Sample">CHAPTER VII</span><br class="calibre"/>
<span href="#/Text/Section0010#CHAPTER_VIII" title="Link target outside of Sample">CHAPTER VIII</span><br class="calibre"/>
<span href="#/Text/Section0011#CHAPTER_IX" title="Link target outside of Sample">CHAPTER IX</span><br class="calibre"/>
<span href="#/Text/Section0012#CHAPTER_X" title="Link target outside of Sample">CHAPTER X</span><br class="calibre"/>
<span href="#/Text/Section0013#CHAPTER_XI" title="Link target outside of Sample">CHAPTER XI</span><br class="calibre"/>
<span href="#/Text/Section0014#CHAPTER_XII" title="Link target outside of Sample">CHAPTER XII</span><br class="calibre"/>
<span href="#/Text/Section0015#CHAPTER_XIII" title="Link target outside of Sample">CHAPTER XIII</span></div>
<p class="calibre1"><a id="pgepubid00001" title="[1]"></a></p>
<div class="figcenter"><img alt="" class="calibre2" src="Images/img0010.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?3744c2d5